module.exports = __webpack_public_path__ + "img/lxwmbanner.6011b45c.png";